const feedbacks = {
  toasts: {
    create: {
      success: 'Feedback criado com sucesso',
      error: 'Ocorreu um erro ao criar o feedback',
    },
    fetch: {
      error: 'Ocorreu um erro ao obter os feedbacks',
    },
    delete: {
      error: 'Ocorreu um erro ao excluir o feedback',
    },
  },
  deleteModal: {
    header: 'Excluir feedback',
    body: 'Você está prestes a excluir um feedback',
    bulkBody: 'Você está prestes a excluir {{num}} feedbacks',
    success: 'Feedback excluído com sucesso',
  },
  table: {
    headers: {
      date: 'Data',
      source: 'Origem',
      id: 'ID',
      externalId: 'ID externo',
      flight: 'Voo',
      airline: 'Companhia aérea',
      account: 'Conta',
      driver: 'Motorista',
      vehicle: 'Veículo',
      feedback: 'Feedback',
      rating: 'Avaliação',
      by: 'Por',
      phone: 'Telefone',
      contact: 'Contato',
    },
    filters: {
      flight: 'Voo',
      airline: 'Companhia aérea',
      driver: 'Motorista',
      vehicle: 'Veículo',
    },
    source: {
      crewLink: 'CrewLink',
      qr: 'QR',
      tripCard: 'Cartão de viagem',
    },
    actions: {
      delete: 'Excluir',
    },
    toolTip: {
      noPermission: 'Ação não permitida: permissão necessária',
    },
  },
};

export default feedbacks;
